import types from './actionTypes';

const initialState = {
  loading: false,
  error: '',
  target: null,
  session: null,
  messages: [],
  events: [],
  status: null,
  cost: { turnUsd: 0, sessionUsd: 0 },
  turnsLeft: null,
};

// A turn arrives whole: the server sends the full transcript and the status as
// they stand, so those are replaced rather than merged — a partial merge is a
// way to invent a history nobody had. Events are the exception: they are a
// log, and a log accumulates.
const applyTurn = (state, action) => {
  // A turn arriving with nothing in flight belongs to a session the colleague
  // already discarded. Applying it would bring back a conversation they threw
  // away — with the transcript whole and the event log emptied by the discard,
  // so the two halves of the screen would disagree. DISCARD and resetState both
  // clear `loading`, which makes that flag the entire test.
  if (!state.loading) return state;

  return {
    ...state,
    loading: false,
    error: '',
    session: action.session,
    messages: action.messages || [],
    events: [...state.events, ...(action.events || [])],
    status: action.status || null,
    cost: action.cost || state.cost,
    turnsLeft:
      action.turnsLeft === undefined ? state.turnsLeft : action.turnsLeft,
  };
};

const aiSimulationReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.RESET_AI_SIMULATION_STATE:
      return { ...initialState };

    // Everything the simulation produced goes, the choice of what to simulate
    // stays: this is what runs when a persisted session is no longer valid.
    case types.DISCARD_AI_SIMULATION:
      return { ...initialState, target: state.target };

    // The error is persisted with the rest of the slice, so without this it
    // outlives the page that produced it and greets whoever opens the
    // simulator next — about an agent they did not ask about.
    case types.CLEAR_AI_SIMULATION_ERROR:
      return { ...state, error: '' };

    case types.START_AI_SIMULATION.REQUEST:
      return {
        ...initialState,
        loading: true,
        target: {
          agentId: action.agentId,
          acquisitionOrderId: action.acquisitionOrderId,
        },
      };

    case types.REPLY_AI_SIMULATION.REQUEST:
    case types.ADVANCE_AI_SIMULATION.REQUEST:
      return { ...state, loading: true, error: '' };

    case types.START_AI_SIMULATION.SUCCESS:
    case types.REPLY_AI_SIMULATION.SUCCESS:
    case types.ADVANCE_AI_SIMULATION.SUCCESS:
      return applyTurn(state, action);

    // The session survives a failure on purpose: a model timeout must not cost
    // the colleague the conversation they have built.
    case types.START_AI_SIMULATION.FAILURE:
    case types.REPLY_AI_SIMULATION.FAILURE:
    case types.ADVANCE_AI_SIMULATION.FAILURE:
      return { ...state, loading: false, error: action.error.message };

    default:
      return state;
  }
};

export default aiSimulationReducer;
